// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1BYuk","header":"ReportDetails_header__1FeWM","title":"ReportDetails_title__5Y7ZT","left":"ReportDetails_left__1e9W-"};